import { Box } from "@twilio-paste/core/box";
import React from "react";
import { SITE_CONTENT_MAX_WIDTH } from "../../constants";
import { SiteFooterIllustration } from "./SiteFooterIllustration";
import { SiteFooterNav } from "./SiteFooterNav";
import { SiteFooterTopAngle } from "./SiteFooterTopAngle";

const Footer: React.FC<{ slantedFooter?: boolean }> = ({ slantedFooter }) => (
    <Box
        style={{
            gridArea: "footer"
        }}
        as="footer"
        margin="space70"
        marginTop={[slantedFooter ? "space200" : "space0", slantedFooter ? "space200" : "space0", "space200"]}
        paddingTop={[slantedFooter ? "space200" : "space0", slantedFooter ? "space200" : "space0", "space200"]}
        position="relative"
    >
        {slantedFooter && <SiteFooterTopAngle />}
        <Box
            borderRadius="borderRadius20"
            backgroundColor="colorBackgroundBrandStronger"
            marginTop={["space0", "space0", "space0", "space0", "space200"]}
            paddingTop={["space0", "space0", "space0", "space0", "space200"]}
        >
            <Box
                maxWidth={SITE_CONTENT_MAX_WIDTH}
                padding={["space90", "space180"]}
                marginTop="space10"
                marginLeft="auto"
                marginRight="auto"
                position="relative"
            >
                <SiteFooterIllustration />
                <SiteFooterNav />
            </Box>
        </Box>
    </Box>
);

export { Footer };
